import React, { Component } from 'react';
import { toast } from 'react-toastify';
import debounce from 'lodash.debounce';
import { PiArrowsOutThin, } from "react-icons/pi";
import InfiniteScroll from 'react-infinite-scroller';
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import { Image, Modal, Row, Button, InputGroup, FormControl, Form } from 'react-bootstrap';
import imageDefault from "../../../assets/campaign-thumbnail-phishing.png";
import PreviewThumbnail from "../../../component/preview/preview";

import axios from '../../../axios';
import './import-landing-from-store.css';
import Loader from '../../loader/loader';

export default class ImportAwarenessFromStore extends Component {
    constructor(props) {
        super(props);
        this.awarenessPageRef = React.createRef();
        this.state = {
            search: "",
            templates: [],
            hasMore: true,
            page: 1,
            awarenessPageId: null,
            categories: [],
            languages: [],
            selectedLanguageId: "",
            selectedCategoryId: "",
            loading: false,
            totalCount: 0,
            showThumbnail: false,
            currentSrc: "",
        };
        this.loadAwarenessPagesDebounced = debounce(this.loadAwarenessPagesDebounced.bind(this), 500);
    }

    loadAwarenessPagesPagesFromStore = () => {
        if (this._awarenessListFetchInFlight || !this.state.hasMore) {
            return;
        }
        this._awarenessListFetchInFlight = true;
        let { search, selectedLanguageId, selectedCategoryId, page } = this.state;
        axios.post(`/api/store/list-awarenesspages`, { page, searchQuery: search, languageId: selectedLanguageId, categoryId: selectedCategoryId })
            .then(response => response.data)
            .then(data => {
                if (data && data.response) {
                    this.setState(prevState => ({
                        templates: prevState.page === 1 ? data.response : [...prevState.templates, ...data.response],
                        hasMore: data.response.length > 0,
                        page: prevState.page + 1,
                        totalCount: data.totalCount || 0
                    }));
                } else {
                    this.setState({ hasMore: false });
                }
            })
            .catch(err => console.log(err))
            .finally(() => {
                this._awarenessListFetchInFlight = false;
            });
    }
    loadAwarenessPagesDebounced = (searchQuery, selectedLanguageId, selectedCategoryId) => {
        axios.post(`/api/store/list-awarenesspages`, { page: 1, searchQuery, languageId: selectedLanguageId, categoryId: selectedCategoryId })
            .then(response => response.data)
            .then(responseData => {
                if (responseData && responseData.response) {
                    this.setState(prevState => ({
                        templates: responseData.response,
                        hasMore: true,
                        page: 2
                    }));
                    if (this.awarenessPageRef.current) {
                        this.awarenessPageRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                } else {
                    this.setState({ hasMore: false });
                }
            })
            .catch(err => console.log(err));
    }
    loadCategory = () => {
        axios.get("/api/store/fetch-categories", {})
            .then((res) => {
                this.setState({ categories: res.data.response });
            })
            .catch(err => console.log(err));
    };

    loadLanguage = () => {
        axios.get("/api/store/fetch-languages", {})
            .then((res) => {
                this.setState({ languages: res.data.response });
            })
            .catch(err => console.log(err));
    };

    componentDidMount() {
        this.loadCategory();
        this.loadLanguage();
        if (this.props.showImportModal) {
            this.loadAwarenessPagesPagesFromStore();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.showImportModal !== this.props.showImportModal && this.props.showImportModal) {
            this.setState({
                templates: [],
                page: 1,
                hasMore: true,
                awarenessPageId: null,
                search: "",
                selectedLanguageId: "",
                selectedCategoryId: "",
            }, () => {
                if (this.state.categories.length === 0) {
                    this.loadCategory();
                }
                if (this.state.languages.length === 0) {
                    this.loadLanguage();
                }
                this.loadAwarenessPagesPagesFromStore();
            });
            return;
        }
        if (prevState.search !== this.state.search) {
            const { search, selectedLanguageId, selectedCategoryId } = this.state;
            this.loadAwarenessPagesDebounced(search, selectedLanguageId, selectedCategoryId);
        } else if (prevState.selectedLanguageId !== this.state.selectedLanguageId || prevState.selectedCategoryId !== this.state.selectedCategoryId) {
            this.setState({ templates: [], page: 1, hasMore: true }, () => {
                if (this.awarenessPageRef.current) {
                    this.awarenessPageRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                this.loadAwarenessPagesPagesFromStore();
            });
        }
    }

    loadHtml = (awarenessPageId) => {
        this.setState({ loading: true });
        axios.get(`/api/store/fetch-awareness/${awarenessPageId}`)
            .then(response => response.data)
            .then(responseData => {
                this.setState({ loading: false });
                if (responseData && responseData.response) {
                    this.props.handleLoadSelectedStoreTemplateHtml(responseData.response.html, responseData.response.name);
                    this.handleCloseLocal();
                } else {
                    toast.error('AwarenessPage HTML not found');
                }
            })
            .catch(err => {
                this.setState({ loading: false });
                console.log(err);
            });
    }

    handleCardClick = () => {
        this.loadHtml(this.state.awarenessPageId);
    }

    handleCloseLocal = () => {
        this._awarenessListFetchInFlight = false;
        this.setState({
            search: "",
            templates: [],
            hasMore: true,
            page: 1,
            awarenessPageId: null,
            selectedLanguageId: "",
            selectedCategoryId: ""
        });
        this.props.handleClose()
    }

    render() {
        const { templates, hasMore, awarenessPageId } = this.state;
        const { showImportModal, handleClose } = this.props;

        return (
            <>
                <Modal className="info-filter mainfooterModal emailRight right" style={{ overflowY: 'auto' }} show={showImportModal} onHide={this.handleCloseLocal} autoFocus keyboard>
                    <Modal.Header closeButton>
                        <div>
                            <h5>Awareness Page Template</h5>
                        </div>
                    </Modal.Header>
                    <div className="filter-wrapper">
                        <div className="alignItemsCenter row">
                            <div className="col-md-3 p-0">
                                <div className="positionSearchIcon">
                                    <InputGroup className="search-wrap">
                                        <FormControl type="text" placeholder="Search" value={this.state.search} onChange={e => this.setState({ search: e.target.value, page: 1 })} className="inputSearch mr-sm-2 form-control" /><SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                    </InputGroup>
                                </div>
                            </div>
                            <div className="col-md-9 pr-0" style={{ display: 'flex' }}>
                                <div className="col-md-9 pr-0">
                                    <div className="rightFilters">
                                        <Form.Group controlId="exampleForm.ControlSelect1" onChange={(e) => this.setState({ selectedLanguageId: e.target.value, page: 1 })} className="d-inline-block">
                                            <Form.Control as="select" className="mr-0 btn">
                                                <option value="">Language</option>
                                                {this.state.languages.map((lang, index) => (
                                                    <option key={index} value={lang.id}>{lang.name}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                </div>
                                <div>
                                    <div >
                                        <Form.Group controlId="exampleForm.ControlSelect1" onChange={(e) => this.setState({ selectedCategoryId: e.target.value, page: 1 })} className="d-inline-block">
                                            <Form.Control as="select" className="mr-0 btn">
                                                <option value="">Category</option>
                                                {this.state.categories.map((category, index) => (
                                                    <option key={index} value={category.id}>{category.name}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <Modal.Body>
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={this.loadAwarenessPagesPagesFromStore}
                            hasMore={hasMore}
                            loader={<div className="loader" key={0}>Loading.......</div>}
                            useWindow={false}
                        >
                            <Row className='landingPageCard emailCard' ref={this.awarenessPageRef}>
                                {(templates?.length > 0) ? (templates.map((template, index) => (
                                    <div key={index} className='col-md-4 p-0'>
                                        <div className="img-hover-wrap templateView"
                                        >

                                            <div className={`cardWrap ${this.state.awarenessPageId === template.id ? 'selectActive' : ''}`}
                                                style={{
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                    boxShadow: awarenessPageId === template.id ? '0 5px 10px rgba(0, 0, 0, 0.3)' : '0 1px 3px rgba(0, 0, 0, 0.2)',
                                                    transform: awarenessPageId === template.id ? 'scale(0.98)' : 'scale(1)',
                                                    transition: 'transform 0.1s, box-shadow 0.1s'
                                                }}
                                                onClick={() => this.setState({ awarenessPageId: template.id })}
                                            >
                                                <img src={template?.thumbnail ? template?.thumbnail: imageDefault } className="img-fluid" alt=""></img>
                                                <div className='hover-btn' onClick={e => {
                                                    if (template?.thumbnail) {
                                                        this.setState({
                                                            showThumbnail: true,
                                                            currentSrc: template?.thumbnail,
                                                        });
                                                    } else {
                                                        toast.info('Email Template Image Not Available');
                                                    }
                                                }}>
                                                    <PiArrowsOutThin className="btn-icon" />
                                                </div>

                                                <div className='cardContent'>
                                                    <h6>{template.name}</h6>
                                                    <div className='cardfooterBox'>
                                                        <span className='badge badgeTwo'>{template.category}</span>
                                                        <span className='badge badgeOne'>{template.language}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                ))) : ("No data found")}
                            </Row>
                        </InfiniteScroll>
                    </Modal.Body>
                    <div className="modalFooter">
                        <div className="col-md-6">
                            <p className="selectedTemp mb-0">Total: {this.state.totalCount}</p>
                        </div>
                        <div className="col-md-6 text-right">
                            <button onClick={this.handleCloseLocal} type="button" className="btn closeBtn">Cancel</button>
                            <Button disabled={this.state.awarenessPageId ? false : true} onClick={() => this.handleCardClick()} className='btn btn-success ml-2'>Select Awareness Page</Button>
                        </div>
                    </div>
                </Modal>
                <PreviewThumbnail
                    src={this.state.currentSrc}
                    attackType={this.props.attackType}
                    showModal={this.state.showThumbnail}
                    showHandle={e => this.setState({ showThumbnail: false })}
                    template={this.state.previewTemplate} // add this line
                    previewType="page"
                />
                { this.state.loading && <Loader /> }
            </>
        );
    }
}
